import React from "react";

import AboutUs from "../components/AboutUs";
import Layout from "../components/Layout";

const AboutusPage = () => {
	return (
		<Layout>
			<AboutUs />
		</Layout>
	);

};

export default AboutusPage;
